module.exports = __webpack_public_path__ + "media/img/round-checkmark-56ef21e249eadbf86ff69e3964ce9ce5.svg";